// extracted by mini-css-extract-plugin
export default {"cls1":"EmlWAMc_sZ3KwdKReR2I","cls2":"oXK_CQQWyFmreMBD2OGg EmlWAMc_sZ3KwdKReR2I"};